module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/113-greenland-53f8a662f7ea8cb8db7a316ea6066337.svg";